module.exports = __webpack_public_path__ + "img/b1d4810.jpg";